import React, { useEffect } from "react"
import { Route, Routes } from "react-router-dom";
import { CHECK_REWARDS_ROUTE, CONFIRM_REGISTER_ROUTE, EMPTY_ROUTE, RESET_PASSWORD_ROUTE, SHARE_PROMO_CODE_ROUTE, SOCIAL_AUTH_CALLBACK_ROUTE } from "./constants/routes";
import CheckRewardsPage from "./pages/checkRewardsPage/CheckRewardsPage";
import ConfirmRegisterPage from "./pages/confirmRegisterPage/ConfirmRegisterPage";
import EmptyPage from "./pages/emptyPage/EmptyPage";
import ResetPasswordPage from "./pages/resetPasswordPage/ResetPasswordPage";
import SharePromoCodePage from "./pages/sharePromoCodePage/SharePromoCodePage";
import AOS from 'aos';
import 'aos/dist/aos.css'
import SocialAuthCallbackPage from "./pages/socialAuthCallbackPage/SocialAuthCallbackPage";

const Root = () => {
	useEffect(() => {
		AOS.init({
			once: true,
		});
	}, [])

	return (
		<Routes>
			<Route path={`${RESET_PASSWORD_ROUTE}/:slug`} element={<ResetPasswordPage />} />
			<Route path={`${CHECK_REWARDS_ROUTE}/:slug`} element={<CheckRewardsPage />} />
			<Route path={EMPTY_ROUTE} element={<EmptyPage />} />
			<Route path={`${CONFIRM_REGISTER_ROUTE}/:id/:hash`} element={<ConfirmRegisterPage />} />
			<Route path={`${SHARE_PROMO_CODE_ROUTE}/:code`} element={<SharePromoCodePage />} />
			<Route path={`${SOCIAL_AUTH_CALLBACK_ROUTE}/:provider`} element={<SocialAuthCallbackPage />} />
		</Routes>
	);
};

export default React.memo(Root);
